import { SelectOption } from "../components/LSelect";

export const getPaginationDropdownOptions = (pages: number): SelectOption[] => {
    const ret = [] as SelectOption[];

    for (let i = 0; i < pages; i++) {
        const page = (i + 1).toString();
        ret.push({ name: "Page " + page, value: page });
    }

    return ret;
};

export const getPaginationPageSizeOptions = (): SelectOption[] => {
    const ret = [] as SelectOption[];
    const vals = [10, 20, 50, 100];
    vals.forEach((v) => ret.push({ name: v.toString(), value: v.toString() }));
    return ret;
};
